import { createTheme } from "@mui/material/styles";
import components from "./overrides";
import palette from "./palette";

const theme = createTheme({
  components,
  palette,
});

export default theme;
